document.addEventListener('DOMContentLoaded', function() {
  var countdownBlocks = document.querySelectorAll('.countdown-timer');

  countdownBlocks.forEach(function(block) {
    var targetDateStr = block.getAttribute('data-target-date');
    var targetDate = new Date(targetDateStr.replace(/-/g, '/')).getTime();
    var isPaused = false;
    var interval;

    function updateCountdown() {
      if (!isPaused) {
        var now = new Date().getTime();
        var distance = targetDate - now;

        if (distance < 0) {
          block.innerHTML = "Le compte à rebours est terminé !";
          clearInterval(interval);
          return;
        }

        var months = Math.floor(distance / (1000 * 60 * 60 * 24 * 30)); // Approximation pour mois
        var days = Math.floor((distance % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        block.innerHTML =
          "<div class='countdown-unit'><span>" + months + "</span><small>mois</small></div>" +
          "<div class='countdown-separator'> : </div>" +
          "<div class='countdown-unit'><span>" + days + "</span><small>jours</small></div>" +
          "<div class='countdown-separator'> : </div>" +
          "<div class='countdown-unit'><span>" + hours + "</span><small>heures</small></div>" +
          "<div class='countdown-separator'> : </div>" +
          "<div class='countdown-unit'><span>" + minutes + "</span><small>minutes</small></div>" +
          "<div class='countdown-separator'> : </div>" +
          "<div class='countdown-unit'><span>" + seconds + "</span><small>secondes</small></div>";
      }
    }

    // Appeler la fonction immédiatement pour éviter le délai initial
    updateCountdown();

    // Démarrer ensuite l'intervalle pour actualiser toutes les secondes
    interval = setInterval(updateCountdown, 1000);
  });
});
